import { FC, memo } from 'react';
import { Table } from 'shared/ui/Table';
import { FormalizedZipListItem } from 'entities/formalizedZip';
import { FORMALIZED_ZIP_TABLE_COLUMNS } from '../../constants/formalizedZipConstants';

interface FormalizedZipTableProps {
  items: FormalizedZipListItem[];
  onEdit: (item: FormalizedZipListItem) => void;
  onDelete: (id: number) => void;
}

export const FormalizedZipTable: FC<FormalizedZipTableProps> = memo(({ items, onEdit, onDelete }) => {
  const actions = [
    {
      key: 'edit',
      label: 'Редактировать',
      onClick: (record: FormalizedZipListItem) => onEdit(record),
    },
    {
      key: 'delete',
      label: 'Удалить',
      onClick: (record: FormalizedZipListItem) => onDelete(record.id as number),
      danger: true,
    },
  ];

  return (
    <Table
      columns={FORMALIZED_ZIP_TABLE_COLUMNS}
      dataSource={items}
      rowKey="id"
      hasPagination
      actions={actions}
      enableFullTableSearch
      enableClearFilters
    />
  );
});

FormalizedZipTable.displayName = 'FormalizedZipTable';
